import {
  angular,
  astro,
  nativescript,
  next,
  nuxt,
  qwik,
  react,
  remix,
  remotion,
  slidev,
  svelte,
  typescript,
  vite,
  vue,
} from "../assets/image";
import { IMAGE } from "../type";

export const FIRST_WORKFLOW_ITEMS: IMAGE[] = [
  {
    image: angular,
    alt: "agular",
  },
  {
    image: astro,
    alt: "astro",
  },
  {
    image: nativescript,
    alt: "nativescript",
  },
  {
    image: next,
    alt: "next",
  },
  {
    image: nuxt,
    alt: "nuxt",
  },
  {
    image: qwik,
    srcSet: "",
    alt: "qwik",
  },
  {
    image: react,
    alt: "react",
  },
];

export const SECOND_WORKFLOW_ITEMS: IMAGE[] = [
  {
    image: remix,
    alt: "remix",
  },
  {
    image: remotion,
    alt: "remotion",
  },
  {
    image: slidev,
    alt: "slidev",
  },
  {
    image: svelte,
    srcSet: "",
    alt: "svelte",
  },
  {
    image: typescript,
    alt: "typescript",
  },
  {
    image: vite,
    alt: "vite",
  },
  {
    image: vue,
    alt: "vue",
  },
];
